import { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { supabase } from '@/lib/supabaseClient';
import { SITE_KEY } from '@/lib/traffic';

// Tracked short link: /go/<code> → the link's page, tagged with its UTM
// values and ?lk=<code> so the visit (and any order) counts for this link.
// Links are created on the Analytics page (traffic_links).
export default function GoLink() {
  const { code = '' } = useParams();
  const [missing, setMissing] = useState(false);

  useEffect(() => {
    supabase.rpc('traffic_resolve_link', { p_site: SITE_KEY, p_code: code }).then(({ data }) => {
      const link = (data as { target_path: string; utm_source: string; utm_medium: string | null; utm_campaign: string; utm_content: string | null }[] | null)?.[0];
      if (!link) {
        setMissing(true);
        window.setTimeout(() => window.location.replace('/'), 2500);
        return;
      }
      const url = new URL(link.target_path, window.location.origin);
      url.searchParams.set('utm_source', link.utm_source);
      if (link.utm_medium) url.searchParams.set('utm_medium', link.utm_medium);
      url.searchParams.set('utm_campaign', link.utm_campaign);
      if (link.utm_content) url.searchParams.set('utm_content', link.utm_content);
      url.searchParams.set('lk', code.toLowerCase());
      // A full load, so the landing page records the tags as the visit's start.
      window.location.replace(url.toString());
    });
  }, [code]);

  return (
    <div style={{ minHeight: '60vh', display: 'flex', alignItems: 'center', justifyContent: 'center', fontFamily: 'system-ui, sans-serif', color: '#6B7280', fontSize: 14 }}>
      {missing ? 'This link is no longer active — taking you to the home page…' : 'Opening…'}
    </div>
  );
}
